'use client'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

import { urlWithParams } from '@marketplace-web/browser/url-util'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'

import { CREATE_BUNDLE_URL } from '../../constants/routes'
import StartBundleButtonWrapper from '../StartBundleButtonWrapper'

type Props = ConversationActionProps

const UpdateBundle = ({ primary, title, inverse, theme, size }: Props) => {
  const { conversation } = useConversationContext()
  const transactionId = conversation?.transactionId
  const oppositeUserId = conversation?.oppositeUser?.id

  if (!oppositeUserId || !transactionId) return null

  const updateBundleUrl = urlWithParams(CREATE_BUNDLE_URL(oppositeUserId), {
    transacion_id: transactionId,
  })

  return (
    <StartBundleButtonWrapper
      url={updateBundleUrl}
      screen="message_reply"
      itemIds={conversation?.transaction?.order.itemIds}
    >
      {({ onClick }) => (
        <ConversationActionButton
          size={size}
          text={title}
          theme={theme}
          primary={primary}
          inverse={inverse}
          onClick={onClick}
        />
      )}
    </StartBundleButtonWrapper>
  )
}

export default UpdateBundle
